import React from 'react';
import { TrialPeriod } from 'commons/services/configurationService/configurationServiceResponses';
import { IdentityValidationCard } from '../IdentityValidationCard';
import {
  PendingTrialPeriodAlert,
  PendingTrialPeriodAlertPage,
} from '../PendingTrialPeriodAlert';

interface InterfacePendingAlert {
  trialPeriod?: TrialPeriod;
  page: PendingTrialPeriodAlertPage;
  blockedTrialPeriod?: boolean;
}

const PendingAlert = ({
  trialPeriod,
  page,
  blockedTrialPeriod,
}: InterfacePendingAlert): JSX.Element | null => {
  if (trialPeriod) {
    return (
      <PendingTrialPeriodAlert
        trialPeriod={trialPeriod}
        page={page}
        blockedTrialPeriod={blockedTrialPeriod}
      />
    );
  }

  return <IdentityValidationCard page={page} />;
};

export default PendingAlert;
